<mat-nav-list appAccordion>
  <mat-list-item appAccordionLink *ngFor="let menuitem of menuItems.getMenuitem()" routerLinkActive="selected" group="{{menuitem.state}}">
    <a class="w-100 p-2" fxLayout="row"  appAccordionToggle [routerLink]="['/', menuitem.state]" routerLinkActive="active-link" *ngIf="menuitem.type === 'link'">
      <img class="navbar-icon-size" src="{{menuitem.icon}}">
      <span class="ml-5">{{ menuitem.name }}</span>
    </a>
  </mat-list-item>
</mat-nav-list>
